import { StructuredDate } from './types';

export default (date: Date): StructuredDate => ({
    year: date.getUTCFullYear(),
    month: date.getUTCMonth(),
    date: date.getUTCDate(),
});
